import { Observer } from 'mobx-react-lite';
import React from 'react';
import { Form } from '../../mediators/form.mediator';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import BaseInput, { BaseInputProps } from '../BaseInput/BaseInput';
import { useFormContext } from '../FormForm/Form.context';
// import './FormInput.scss';

type FormInputProps<T extends object = object> = Omit<BaseInputProps<T>, 'form'> & {
  form?: Form<T>,
}

function FormInput<T extends object = object>(
  props: React.PropsWithChildren<FormInputProps<T>>
) {

  const context = useFormContext<T>();
  const { form } = context;
  const p = useProps(props);
  const s = useStore(() => ({
    get form() { return p.form ?? form },
  }));

  return <Observer children={() => (
    <BaseInput {...p}
      className={joinClassName('FormInput', p.className)}
      form={s.form.fields[p.field]}
      field="value"
      name={p.name ?? p.field}
      disabled={p.disabled || context.disabled || !s.form.editableFieldNames.includes(p.field)}
      // disabled={p.disabled || context.disabled}
    />
  )} />
}

export default FormInput;